const paths = {
  geofencesList: '/geofences/list',
  geofencesAssign: '/geofences/assign',
  geofencesAssignedList: '/geofences/assigned-list'
};

export default paths;
